import {
  ThumbUp as AcceptIcon,
  ThumbDown as DeclineIcon,
} from '@mui/icons-material';
import { Box, Button } from '@mui/material';
import {
  acceptIconSx,
  actionButtonSx,
  compactButtonsContainerSx,
  declineIconSx,
  expandedButtonsContainerSx,
} from './SuggestedDocumentReference.styles';

interface SuggestionActionButtonsProps {
  acceptLabel: string;
  dismissLabel?: string;
  onAccept: () => void;
  onDecline: () => void;
  centered?: boolean;
}

const SuggestionActionButtons = ({ acceptLabel, dismissLabel = 'Dismiss', onAccept, onDecline, centered }: SuggestionActionButtonsProps) => (
  <Box sx={centered ? expandedButtonsContainerSx : compactButtonsContainerSx}>
    <Button
      variant="outlined"
      size="small"
      onClick={onAccept}
      endIcon={<AcceptIcon sx={acceptIconSx} />}
      sx={actionButtonSx}
    >
      {acceptLabel}
    </Button>
    <Button
      variant="outlined"
      size="small"
      onClick={onDecline}
      endIcon={<DeclineIcon sx={declineIconSx} />}
      sx={actionButtonSx}
    >
      {dismissLabel}
    </Button>
  </Box>
);

export default SuggestionActionButtons;
